export const SELECT_LIMIT = 20;
export const HEX_COLORS = [
  '#f22f23',
  '#1e9773',
  '#004984',
  '#f2de00',
  '#231f21',
  '#99938f',
  '#d32481',
  '#c65223',
];
export const COLOR_BUTTON_SIZE = 49;
export const COLOR_BUTTON_SELECTED = 30;
